import "./errors.css";

const Error404 = () => {
  return (
    <div className="errorContainer">
      <p>
        <span>Error 404:</span> Page not found.
      </p>
    </div>
  );
};

export default Error404;
